import { Avatar, Button, Stack, SxProps, Typography } from '@mui/material';
import { KeyboardEvent } from 'react';

interface IRadioIconButtons {
  options: string[];
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
  labelledby: string;
  iconSrcArray: string[];
  iconSx?: SxProps;
}

export const RadioIconButtons = ({
  options,
  setValue,
  value,
  labelledby,
  iconSrcArray,
  iconSx,
}: IRadioIconButtons) => {
  const handleThoughtsKeyDown = (
    e: KeyboardEvent<HTMLButtonElement>,
    index: number
  ) => {
    switch (e.key) {
      case ' ':
      case 'Enter':
        e.preventDefault();
        setValue(options[index]);
        break;
      case 'ArrowDown':
      case 'ArrowLeft':
        e.preventDefault();
        const nextIndex = index + 1 < options.length ? index + 1 : 0;
        const nextButton = document.getElementById(
          options[nextIndex].replaceAll(' ', '-')
        );
        nextButton?.focus();
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        e.preventDefault();
        const prevIndex = index - 1 >= 0 ? index - 1 : options.length - 1;
        const prevButton = document.getElementById(
          options[prevIndex].replaceAll(' ', '-')
        );
        prevButton?.focus();
        break;
      default:
        break;
    }
  };

  return (
    <Stack
      sx={{ flexDirection: 'row', gap: '16px' }}
      aria-labelledby={labelledby}
      role='radiogroup'
    >
      {options.map((option, index) => (
        <Button
          key={option.replaceAll(' ', '-')}
          variant='secondary'
          sx={{
            border: 'none',
            boxShadow: '0px 2px 14px 0px rgba(8, 30, 84, 0.08)',
            p: '10px 0px',
            bgcolor: value === option ? 'primary.shade_200' : 'white',
            color: '#344266',
            flexDirection: 'column',
            gap: '10px',
            width: '120px',
          }}
          onClick={() => {
            setValue(option);
          }}
          role='radio'
          aria-checked={value === option}
          onKeyDown={(e) => handleThoughtsKeyDown(e, index)}
          id={option.replaceAll(' ', '-')}
        >
          <Avatar
            alt=''
            src={iconSrcArray[index]}
            sx={{ width: '40px', height: '32px', ...iconSx }}
          />
          <Typography variant='body6'>{option}</Typography>
        </Button>
      ))}
    </Stack>
  );
};
